module.exports = __webpack_public_path__ + "img/sixpackcarrier19.314e01d7.jpg";